module.exports = __webpack_public_path__ + "img/101-ei-01.prt.e57a4a55.jpg";